import { render, staticRenderFns } from "./ButtonWithConfirmAndComment.vue?vue&type=template&id=de16b718"
import script from "./ButtonWithConfirmAndComment.vue?vue&type=script&lang=ts"
export * from "./ButtonWithConfirmAndComment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports